<template>
  <div
    v-if="!NoFooter"
    class="w-full h-24 flex-c flex-col bg-[#f5f5f5]"
    :style="{
      paddingBottom: hasApplyMember ? '64px' : '0',
      marginBottom: isJCInsurance ? isCn?'64px':'104px' : '0',
    }"
  >
    <div class="base-footer">
      <p>Copyright © www.jctrans.com All rights reserved.</p>
      <!-- <div class="flex-c">
        <NuxtImg
          src="https://resources.jctrans.com/res/jc/pc/img/gh.png"
          alt=""
          class="h-[20px] mr-[5px] ml-[10px]"
        />
        <a
          class="mr-[10px] cursor-pointer inline-block"
          href="https://beian.mps.gov.cn/#/query/webSearch"
          @click.prevent="
            openByLink('https://beian.mps.gov.cn/#/query/webSearch')
          "
          >辽公网安备21020202000645号</a
        >
      </div> -->
      <a
        class="cursor-pointer inline-block"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        @click.prevent="
          openByLink('https://beian.miit.gov.cn/#/Integrated/index')
        "
      >
        {{ getCnOrEn('辽ICP备2022004632号', 'Registration Number:2022004632') }}
      </a>
      <p>经营许可证：合字B2-20240208</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const route = useRoute()
  const routerName = computed(() => route.name)
  const RouteNameList = [
    'Home',
    'logisticsNewsDetail',
    'JctransNewsDetail',
    'membershipJCTransBenefitsOverview',
    'membershipToolsRiskProcessDetail',
    'riskPreventionRiskCaseDetail',
    'riskPreventionRiskNoticeDetail',

    'Resources',
    'Blog',
    'BlogList',
    'BlogDetail',

    'membershipJCTransIntroduction',

    'membershipJCVF',
  ]
  const hasApplyMember = ref(false)
  const isJCInsurance = ref(false)
  const { isCn } = useVipLogo()
  watch(
    () => route.name,
    (val) => {
      if (val) {
        hasApplyMember.value =
          RouteNameList.includes(val as string) ||
          (route.meta.applyMember ? !!route.meta.applyMember : false)
        isJCInsurance.value = val === 'JCInsurance'
      }
    },
    {
      immediate: true,
    },
  )

  const NoFooterRouteNameList = ['JCPay', 'AppDownload']
  const NoFooter = computed(() =>
    NoFooterRouteNameList.includes(routerName.value as string),
  )
</script>

<style lang="scss" scoped>
  .base-footer {
    height: 30px;
    font-family: Poppins-R, Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px;
    color: #9ea0a6;
    text-align: center;
    text-transform: none;
  }
</style>
